<template>
	<div class="side-menu-container">
		<!-- 收缩按钮 -->
		<!-- 	<div class="collapse-btn" @click="handleCollapse">
			<i class="el-icon-s-fold" v-if="!isCollapse"></i>
			<i class="el-icon-s-unfold" v-else></i>
		</div> -->

		<!-- ElementUI 菜单 -->
		<el-menu :default-active="activeMenu" :collapse="isCollapse" background-color="#fff" text-color="#404040"
			active-text-color="#fff" unique-opened class="el-menu-side">
			<template v-for="item in menuList">
				<!-- 有子菜单 → 子菜单组件 -->
				<el-submenu :index="String(item.id)" v-if="item.children && item.children.length" :key="item.id">
					<template slot="title">
						<i :class="item.icon"></i>
						<span class="menu-parent">{{ item.name }}</span>
					</template>
					<el-menu-item v-for="child in item.children" :index="child.path" :key="child.id"
						@click="handleMenuClick(child)">
						{{ child.name }}
					</el-menu-item>
				</el-submenu>

				<!-- 无子菜单 → 普通菜单项 -->
				<el-menu-item v-else :index="item.path" :key="item.id" @click="handleMenuClick(item)">
					<i :class="item.icon"></i>
					<span slot="title" class="menu-parent">{{ item.name }}</span>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'VueMenu',
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			},
			menuList: {
				type: Array,
				required: true
			},
			activeMenu: {
				type: String,
				default: ''
			}
		},
		methods: {
			handleCollapse() {
				this.$emit('collapse-change', !this.isCollapse)
			},
			handleMenuClick(item) {
				this.$emit('menu-click', item)
			}
		}
	}
</script>

<style scoped>
	/* 定义rem换算函数 */
	@function rem($px) {
		@return calc($px / 16) * 1rem;
	}


	.side-menu-container {
		height: 100vh;
		background-color: #fff;
	}

	::v-deep .menu-parent {
		/* color: #404040; */
		font-size: 20px !important;
		font-weight: 600;
	}
	
	::v-deep .el-menu-item{
		font-size: 20px !important;
		font-weight: 600;
		border-radius: 10px;
		margin-top: 15px;
	}
	
	::v-deep .el-submenu{
		border-radius: 10px;
	}

	.collapse-btn {
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: white;
		font-size: 16px;
		cursor: pointer;
		background-color: #1f2d3d;
	}

	.collapse-btn i {
		font-weight: bold;
	}
	
	::v-deep .is-active{
		background-color: #0064C5 !important;
	}
	


	.el-menu-side {
		border: none;
		height: calc(100vh - 50px);
	}
</style>